import React, { useState, useEffect, useRef } from "react";
import TeacherPanel from "../panel/TeacherPanel";
import api from "../../../api/api";
import "../styles/TeacherClassworkPage.css";

const TeacherClassworkPage = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [classId, setClassId] = useState("");
  const [sectionId, setSectionId] = useState(""); // Use ID
  const [topic, setTopic] = useState("");
  const [date, setDate] = useState("");
  const [videoFile, setVideoFile] = useState(null);
  const [imageFiles, setImageFiles] = useState([]);
  const [comment, setComment] = useState("");
  const [color, setColor] = useState("#00bfff");
  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);

  const videoInputRef = useRef();
  const imagesInputRef = useRef();

  useEffect(() => {
    fetchClasses();
  }, []);

  const fetchClasses = async () => {
    try {
      const res = await api.get("/api/classes", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      setClasses(res.data);
    } catch (err) {
      console.error("Failed to fetch classes:", err);
    }
  };

  const fetchSections = async (classId) => {
    if (!classId) return;
    try {
      const res = await api.get(`/api/sections?classId=${classId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      setSections(res.data);
    } catch (err) {
      console.error("Failed to fetch sections:", err);
    }
  };

  const handleImageUpload = (e) => setImageFiles([...e.target.files]);
  const handleVideoUpload = (e) => setVideoFile(e.target.files[0]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!classId || !sectionId || !topic || !date) {
      return alert("Please fill all required fields.");
    }

    try {
      const formData = new FormData();
      formData.append("classId", classId);
      formData.append("sectionId", sectionId); // Send section ID
      formData.append("topic", topic);
      formData.append("date", date);
      formData.append("comment", comment);
      formData.append("color", color);
      if (videoFile) formData.append("video", videoFile);
      imageFiles.forEach((file) => formData.append("images", file));

      const res = await api.post("/api/classwork", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      alert(res.data.message || "✅ Classwork created successfully");

      // Reset form
      setTopic("");
      setDate("");
      setVideoFile(null);
      setImageFiles([]);
      setComment("");
      setSectionId("");
      setClassId("");
      if (videoInputRef.current) videoInputRef.current.value = "";
      if (imagesInputRef.current) imagesInputRef.current.value = "";
    } catch (err) {
      console.error("Create classwork failed:", err.response || err);
      alert(err.response?.data?.error || "❌ Failed to create classwork");
    }
  };

  return (
    <>
      <TeacherPanel onToggle={setIsSidebarCollapsed} />
      <div className={`cw-main-container ${isSidebarCollapsed ? "cw-collapsed" : ""}`}>
        <h2>Create Classwork</h2>
        <form onSubmit={handleSubmit} className="cw-form">
          <label>Class:</label>
          <select
            value={classId}
            onChange={(e) => {
              setClassId(e.target.value);
              fetchSections(e.target.value);
            }}
            required
          >
            <option value="">-- Select Class --</option>
            {classes.map((c) => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </select>

        <label>Section:</label>
<select value={sectionId} onChange={(e) => setSectionId(e.target.value)} required>
  <option value="">-- Select Section --</option>
  {/* Send section ID to backend */}
  {sections.map((s) => (
    <option key={s.id} value={s.id}>{s.name}</option>
  ))}
</select>


          <label>Topic:</label>
          <input value={topic} onChange={(e) => setTopic(e.target.value)} required />

          <label>Date:</label>
          <input type="date" value={date} onChange={(e) => setDate(e.target.value)} required />

          <label>Video:</label>
          <input ref={videoInputRef} type="file" accept="video/*" onChange={handleVideoUpload} />

          <label>Images:</label>
          <input ref={imagesInputRef} type="file" multiple accept="image/*" onChange={handleImageUpload} />

          <label>Comment:</label>
          <textarea value={comment} onChange={(e) => setComment(e.target.value)} />

          <label>Card Color:</label>
          <input type="color" value={color} onChange={(e) => setColor(e.target.value)} />

          <button type="submit">Save Classwork</button>
        </form>
      </div>
    </>
  );
};

export default TeacherClassworkPage;
